export const getIsPreview = () => {
  const query = window.location.search
  const urlParams = new URLSearchParams(query)
  const isPreview = urlParams.get('isPreview')

  return !!isPreview
}
